import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { EnvironmentNames } from '../../../_core/constants/environments';
import { environment } from '@environment';

@Component({
  selector: 'app-wiring-instructions',
  templateUrl: './wiring-instructions.component.html',
  styleUrls: ['./wiring-instructions.component.scss'],
  standalone: false,
})
export class WiringInstructionsComponent implements OnInit, OnChanges {
  @Input() wiringInstructions: any[];
  @Input() showSupplementary = false;

  environmentNames = EnvironmentNames;
  environment: EnvironmentNames;
  processedInstructions: any[] = [];
  noteFields: Map<number, string> = new Map();

  constructor() {
    this.environment = environment.fund.environmentName;
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['wiringInstructions'] && this.wiringInstructions) {
      this.processInstructions();
    }
  }

  private processInstructions(): void {
    this.processedInstructions = [];
    this.noteFields = new Map();

    this.wiringInstructions.forEach((instruction, index) => {
      const processed = { ...instruction };

      // Handle instructionsSets (used for Swiss USD and potentially others)
      if (instruction.instructionsSets && Array.isArray(instruction.instructionsSets)) {
        processed.instructionsSets = instruction.instructionsSets.map((set: any[]) => {
          // Extract note fields from the set
          const noteField = set.find(field => field.name === 'donate.note');
          if (noteField) {
            this.noteFields.set(index, noteField.value);
          }
          // Return set without note fields
          return set.filter(field => field.name !== 'donate.note');
        });

        // Inject currency as first field in each set
        if (instruction.currency && processed.instructionsSets.length > 0) {
          const currencyField = {
            name: 'currency',
            value: instruction.currency
          };
          processed.instructionsSets = processed.instructionsSets.map((set: any[]) =>
            [currencyField, ...set]
          );
        }
      }

      // Handle fields array (used for other currencies)
      if (instruction.fields && Array.isArray(instruction.fields)) {
        const noteField = instruction.fields.find((field: any) => field.name === 'donate.note');
        if (noteField) {
          this.noteFields.set(index, noteField.value);
        }
        processed.fields = instruction.fields.filter((field: any) => field.name !== 'donate.note');

        // Inject currency as first field
        if (instruction.currency) {
          const currencyField = {
            name: 'currency',
            value: instruction.currency
          };
          processed.fields = [currencyField, ...processed.fields];
        }
      }

      this.processedInstructions.push(processed);
    });
  }

  hasNote(index: number): boolean {
    return this.noteFields.has(index);
  }

  getNote(index: number): string {
    return this.noteFields.get(index) || '';
  }

  isWireRoutingNumber(fieldName: string): boolean {
    return fieldName === 'donate.wire.routing.number';
  }
}
